/**
 * Fonte única dos segmentos de rota do módulo de Serviços (`/servicos/:tipo/**`).
 * Consumido pelo `servicos.routes.ts`, pelo menu do `servicos-content` e pelas navegações do `dashboard-servicos`.
 */
export const SERVICOS_ROUTES = {
    ROOT: 'servicos',
    /** Rota-filha de consulta pontual de protocolo. */
    PROTOCOLO: 'protocolo',
    /** Rota-filha do serviço selecionado (recebe `:codigo`). */
    ITEM: 'item',
    /** Rota-filha de relatórios do módulo. */
    RELATORIOS: 'relatorios'
} as const;

/**
 * Segmentos dos relatórios, filhos de {@link SERVICOS_ROUTES.RELATORIOS}.
 *
 * <p>Existem aqui, e não soltos no `*.routes.ts`, porque **dois** arquivos precisam dos mesmos valores:
 * as rotas-filhas e os `routerLink` da vitrine (`servicos-relatorios-content.ts`). Escritos duas vezes,
 * renomear um caminho deixa um card apontando para rota que não existe — e o item de menu morto é
 * exatamente o defeito que a vitrine veio consertar.</p>
 */
export const SERVICOS_RELATORIOS_ROUTES = {
    ENTRADA_SAIDA: 'entrada-saida',
    DESFECHO: 'desfecho',
    TEMPO_DE_CICLO: 'tempo-de-ciclo',
    RETRABALHO: 'retrabalho',
    CARGA: 'carga',
    ADOCAO: 'adocao',
    /** Envelhecimento: o relatório do "agora". Era rota irmã, direto sob `:tipo`, até virar relatório. */
    ENVELHECIMENTO: 'envelhecimento'
} as const;
